module.exports = __webpack_public_path__ + "img/BANDEAU_ACCUEIL.4ffe7b5f.svg";